/**
 * Created by vladislav on 1/30/19
 */

const DailyCupIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.dailycup_icon_json
    });

    cleverapps.dailyCup.on("update", () => {
        cleverapps.sideBar.resetByClassName(DailyCupIcon);
    });
};

DailyCupIcon.prototype = Object.create(SideBarIcon.prototype);
DailyCupIcon.prototype.constructor = DailyCupIcon;

DailyCupIcon.prototype.getForce = function () {
    return cleverapps.dailyCup.getForce();
};

DailyCupIcon.prototype.resetState = function () {
    const hidedByLocation = cleverapps.config.type !== "merge" && typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation;
    this.available = cleverapps.dailyCup.isAvailable({
        future: true
    }) && !hidedByLocation;

    const locked = this.available && !cleverapps.dailyCup.isAvailable();
    if (this.available && !locked) {
        this.available = cleverapps.dailyCup.isActive();
    }

    if (locked) {
        this.setLocked(true);
        this.setAttention(false);

        this.setTitle(Messages.get("IconLocked.TextDefault", {
            levelNo: this.getLockedTipData()
        }));
    } else {
        this.setLocked(false);
        this.setAttention(!this.locked && cleverapps.dailyCup.isFinished());

        const leftTime = cleverapps.dailyCup.getTimeLeft();
        if (leftTime > 0) {
            this.setLeftTime(leftTime);
            this.setTitle(undefined);
        } else {
            this.setLeftTime(0);
            this.setTitle(Messages.get("Finished"));
        }
    }
};

DailyCupIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "DailyCupSceneFromIcon",
        action: function (f) {
            cleverapps.scenes.replaceScene(bundles.main.jsons.dailycupscene_prefab_json, f);
        }
    });
};

DailyCupIcon.prototype.getLockedTipData = function () {
    const data = CupsConfig.TYPES[CupsConfig.TYPE_DAILY].available;
    return cleverapps.humanReadableNumber({ floatLevel: data.level });
};
